import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.667 6.667a5.333 5.333 0 1 1 10.666 0c0 1.834-.901 3.53-1.898 4.854-1.004 1.331-2.15 2.345-2.736 2.827-.41.336-.988.336-1.398 0-.586-.482-1.732-1.496-2.736-2.827-.997-1.324-1.898-3.02-1.898-4.854m3.25 0a2.083 2.083 0 1 1 4.166 0 2.083 2.083 0 0 1-4.166 0",
		clipRule: "evenodd"
	})
});
export default SvgMapPin;
